import { useEffect, useState } from 'react';
import { FileThumbnail, getFileThumbnail } from './fileThumbnail';

/** Превью файла: `undefined`, пока строится. Без файла (уже сохранённое вложение) — `none`. */
export function useFileThumbnail(file: File | undefined): FileThumbnail | undefined {
    const [state, setState] = useState<{ file?: File; thumb?: FileThumbnail }>({});

    useEffect(() => {
        if (!file) return;
        let alive = true;
        void getFileThumbnail(file).then((thumb) => {
            if (alive) setState({ file, thumb });
        });
        return () => {
            alive = false;
        };
    }, [file]);

    if (!file) return { kind: 'none' };
    return state.file === file ? state.thumb : undefined;
}
